app.component('userSearchBox', {  // This name is what AngularJS uses to match to the `<user-search-box>` element.
  template: `<section class="search-box us-search mb-4" data-list='{"valueNames":["title"]}'>
              <label class="form-label us-search-label">
                Search for Client
                <span class="small-italic">(User ID, First Name, Last Name, Email Address or Tax ID by using # or Prop ID by using @)</span>
              </label>
              <form class="position-relative us-search-form" data-toggle="search" data-display="static">
                <div class="us-search-field">
                  <span class="fas fa-search search-box-icon"></span>
                  <input ng-model="clientSearch.search_filter" ng-keydown="showResultListFocus($event)" aria-label="Search"
                        ng-change="filterUsers()" class="form-control search-input fuzzy-search" type="search" placeholder="Search..."/>
                  <i ng-click="clearSearchBox()" class="fal fa-times us-search-clear"></i>
                </div>
              </form>
              <div ng-if="clientSearch.search_results.length==0" class="user-search-responses">
                No Results
              </div>
              <div ng-if="clientSearch.search_results.length>0" class="user-search-responses">
                <div class="response-list scrollbar">
                  <div ng-repeat="u in clientSearch.search_results" class="user-select" id="search_result_{{$index}}">
                    <div ng-click="clientSearchItemSelected(u)" class="result-wrapper">
                      <div class="row">
                        <div class="col user"></div>
                        <div class="col-auto business_source">
                          <span ng-bind-html="highlight(u.business_source, clientSearch.search_filter)"></span>
                          <span> | </span>
                          <span ng-bind-html="highlight(u.usertype, clientSearch.search_filter)" class="usertype"></span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col username" ng-bind-html="highlight(u.name, clientSearch.search_filter)"></div>
                        <div class="col-auto userid">
                          <span style="font-size: 10px; color: lightgray;">Client ID:</span>
                          <span ng-bind-html="highlight(u.id, clientSearch.search_filter)"></span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col user" ng-bind-html="highlight(u.username, clientSearch.search_filter)"></div>
                        <div ng-if="clientSearch.search_type == 'tax_id' || clientSearch.search_type == 'prop_id'" class="col-auto userid">
                          <span style="font-size: 10px; color: lightgray;">Prop ID:</span>
                          <span ng-bind-html="highlight(u.prop_id, clientSearch.prop_id)"></span>
                        </div>
                      </div>                      
                      <div ng-if="clientSearch.search_type == 'tax_id' || clientSearch.search_type == 'prop_id'" class="row">
                        <div class="col-auto fw-600" style="width: 210px">{{u.cad_code}}-{{u.cad_account}}</div>
                        <div class="col">{{u.situs.num}} {{u.situs.street}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>`,
  bindings: {
    selectionComplete: '&',
  },
  controller: function userSearchBoxController($scope, clientService, $sce, safeApply) {

    $scope.clientSearch = { search_filter: "", results_list_focus: -1, search_results: null, search_type: '' }

    $scope.clearSearchBox = function () {
      clearClientSearchBox()
    }

    function clearClientSearchBox() {
      $scope.clientSearch = { search_filter: "", results_list_focus: -1, search_results: null }
    }
    clearClientSearchBox()

    $scope.filterUsers = async function () {
      if ($scope.clientSearch.search_filter.length == 0 || ($scope.clientSearch.search_filter.length == 1 && $scope.clientSearch.search_filter.charAt(0) == "#")) {
        $scope.clientSearch.search_results = null
        $scope.clientSearch.search_type = ''
        return
      }
      if ($scope.clientSearch.search_filter.charAt(0) == "#") {
        let findUserByTaxIDResults = await clientService.findUserByTaxID({ search: $scope.clientSearch.search_filter.slice(1) })
        $scope.clientSearch.search_results = findUserByTaxIDResults.data.data
        $scope.clientSearch.search_type = 'tax_id'
      } else if ($scope.clientSearch.search_filter.charAt(0) == "@") {
        let findUserByPropDResults = await clientService.findUserByPropID({ search: $scope.clientSearch.search_filter.slice(1) })
        $scope.clientSearch.search_results = findUserByPropDResults.data.data
        $scope.clientSearch.search_type = 'prop_id'
      }
      else {
        let findUserByAnyKeyResults = await clientService.findUserByAnyKey({ search: $scope.clientSearch.search_filter })
        $scope.clientSearch.search_results = findUserByAnyKeyResults.data.data
        $scope.clientSearch.search_type = 'user'
      }
      $scope.clientSearch.results_list_focus = -1
      safeApply($scope)
    }

    // prop_id is passed for Tax ID (#) and Prop ID (@) searches, so the client opens on that property
    $scope.clientSearchItemSelected = (u) => {
      const prop_id = ($scope.clientSearch.search_type == 'tax_id' || $scope.clientSearch.search_type == 'prop_id') ? u.prop_id : null
      this.selectionComplete({ id: u.id, token: u.token, prop_id: prop_id })
      clearClientSearchBox()
    }

    $scope.showResultListFocus = (e) => {
      // Only intercept navigation/action keys so normal typing still works
      // (this runs on keydown, which auto-repeats when a key is held down —
      // giving arrow-key auto-scroll through the results list).
      const navKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', 'Enter', 'Escape']
      if (navKeys.indexOf(e.key) === -1) return
      e.stopPropagation()
      e.preventDefault()
      if (!$scope.clientSearch.search_results) return
      let count = $scope.clientSearch.search_results.length - 1
      angular.element(document.querySelector(`#search_result_${$scope.clientSearch.results_list_focus}`)).removeClass("user-selected")
      if (e.key == 'End') {
        $scope.clientSearch.results_list_focus = count
      } else if (e.key == 'Home') {
        $scope.clientSearch.results_list_focus = 0
      } else if (e.key == 'PageUp') {
        $scope.clientSearch.results_list_focus = $scope.clientSearch.results_list_focus - 7
        if ($scope.clientSearch.results_list_focus < 0) $scope.clientSearch.results_list_focus = count
      } else if (e.key == 'PageDown') {
        $scope.clientSearch.results_list_focus = $scope.clientSearch.results_list_focus + 7
        if ($scope.clientSearch.results_list_focus > count) $scope.clientSearch.results_list_focus = 0
      } else if (e.key == 'ArrowDown') {
        $scope.clientSearch.results_list_focus++
        if ($scope.clientSearch.results_list_focus > count) $scope.clientSearch.results_list_focus = 0
      } else if (e.key == 'ArrowUp') {
        $scope.clientSearch.results_list_focus--
        if ($scope.clientSearch.results_list_focus < 0) $scope.clientSearch.results_list_focus = count
      } else if (e.key == 'Enter') {
        if ($scope.clientSearch.results_list_focus == -1) return
        $scope.clientSearchItemSelected($scope.clientSearch.search_results[$scope.clientSearch.results_list_focus])
      } else if (e.key == 'Escape') {
        clearClientSearchBox()
      }
      angular.element(document.querySelector(`#search_result_${$scope.clientSearch.results_list_focus}`)).addClass("user-selected")
      try {
        var elemn = document.getElementById(`search_result_${$scope.clientSearch.results_list_focus}`)
        // Scroll only within the results list container — NOT the window.
        // scrollIntoView() bubbles to the nearest scrollable ancestor (the page),
        // which caused the whole window to scroll. Adjust the container's
        // scrollTop directly so navigation stays contained to the dropdown.
        var container = elemn.closest('.response-list')
        if (container) {
          var itemTop = elemn.offsetTop
          var itemBottom = itemTop + elemn.offsetHeight
          if (itemTop < container.scrollTop) {
            container.scrollTop = itemTop
          } else if (itemBottom > container.scrollTop + container.clientHeight) {
            container.scrollTop = itemBottom - container.clientHeight
          }
        }
      } catch (error) { }
    }

    $scope.highlight = function (text, search) {
      text = String(text)
      if (!search) {
        return $sce.trustAsHtml(text);
      }
      return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), `<span class="highlightedText">$&</span>`));
    }

  }
})